var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChaticon = function SvgChaticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 10C0 4.477 4.477 0 10 0c4.857 0 8.905 3.462 9.81 8.054C13.518 8.624 8.52 13.68 8.039 20H.5a.5.5 0 0 1-.5-.5V10Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 10c6.075 0 11 4.925 11 11v10.5a.5.5 0 0 1-.5.5H21c-6.075 0-11-4.925-11-11s4.925-11 11-11Zm6 8.9a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-1.8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v1.8Zm-4.5 6.3a.5.5 0 0 0 .5-.5v-1.8a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v1.8a.5.5 0 0 0 .5.5h7Z",
    clipRule: "evenodd"
  })));
};
export default SvgChaticon;